"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BNBUpToken = exports.BNBWrappedToken = exports.BNBNativeToken = void 0;
const utils_1 = require("@unifiprotocol/utils");
exports.BNBNativeToken = new utils_1.Currency("BNB", 18, "BNB", "BNB");
exports.BNBWrappedToken = new utils_1.Currency("0xC578c6e2505Fd2B227A64350ABf85e7221D17c91", 18, "WBNB", "Wrapped BNB");
exports.BNBUpToken = new utils_1.Currency("0x2E37B22aEAAc7767998891E076AB56a6a8b8bbBF", 18, "UP", "UP");
